import { render, staticRenderFns } from "./RevenueRecord.vue?vue&type=template&id=db13591a&scoped=true&"
import script from "./RevenueRecord.vue?vue&type=script&lang=js&"
export * from "./RevenueRecord.vue?vue&type=script&lang=js&"
import style0 from "./RevenueRecord.vue?vue&type=style&index=0&id=db13591a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db13591a",
  null
  
)

export default component.exports